/**
 * CatchBoundary error UI for /stock, /chart, and /technical (error §6).
 *
 * Discriminates InvalidTickerParamError from render-time crashes so a
 * PriceChart exception is never reported as a bad ticker.
 */
import { EmptyState } from '@/components/primitives/empty-state';

import { isInvalidTickerParamError } from './invalid-ticker-param-error';

import type { JSX } from 'react';

export function TickerRouteError({ error }: { readonly error: unknown }): JSX.Element {
  if (isInvalidTickerParamError(error)) {
    return (
      <EmptyState title="Security not found" description="Invalid or unknown ticker in the URL." />
    );
  }
  return (
    <EmptyState
      title="Something went wrong"
      description="This screen could not be displayed. Reload the page to try again."
    />
  );
}
